import type { Incentive } from '../../Recommendations.types'

export const getBonus = (bonus: Incentive['bonus']) => {
  // @ts-ignore
  if (bonus.type === 'SAMPLE_BUDGET') {
    return {
      // @ts-ignore
      value: bonus.amount.value as number,
      // @ts-ignore
      currency: bonus.amount.currency as string,
    }
  }

  return undefined
}
